// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__T550N","question":"styles_question__2afJm","description":"styles_description__2NZMi"};